module.exports = __webpack_public_path__ + "img/bind_iphone_img.921eeece.png";